var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.975 19.633c.402 0 .804-.201 1.106-.503L30.548 5.462a1.577 1.577 0 0 0 0-2.211L28.236.94a1.577 1.577 0 0 0-2.21 0L16.007 10.957 5.975.93a1.577 1.577 0 0 0-2.211 0L1.452 3.24a1.577 1.577 0 0 0 0 2.211L14.92 19.12c.302.302.704.503 1.106.503"
})));
export default SvgIconChevron;